import { FC, type JSX } from 'react';

import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import useDC from '@eneco/dc/useDC';
import { Link } from '@eneco/next';
import {
  Box,
  Divider,
  EnecoLogo,
  Grid,
  OxxioLogo,
  PageGrid,
  ProgressIndicator,
  Stack,
  WoonenergieLogo,
} from '@eneco/sparky';
import { ProgressIndicatorItemProps } from '@eneco/sparky/types';

const labels = {
  eneco: <EnecoLogo />,
  oxxio: <OxxioLogo />,
  woonenergie: <WoonenergieLogo />,
};

type HeaderProps = {
  steps: ProgressIndicatorItemProps[];
  logoLink: string;
  previousButton: JSX.Element | false;
  closeButton: JSX.Element;
  dialog: ReturnType<typeof TrackedDialog>;
};

export const AppHeader: FC<HeaderProps> = ({ steps, logoLink, previousButton, closeButton, dialog }) => {
  const { label } = useDC();

  const showStepsAndDialog = steps.some(step => step.isActive);

  return (
    <Box backgroundColor="backgroundPrimary">
      <PageGrid>
        <PageGrid.Item gridColumn="1/-1">
          <Grid alignY="center" columns="3">
            <Grid.Item>{previousButton}</Grid.Item>
            <Grid.Item>
              <Stack alignX="center">
                <Box paddingTop="3" paddingBottom="2">
                  {logoLink && (
                    <Link href={logoLink} linkType="external">
                      <a href={logoLink}>{labels[label]}</a>
                    </Link>
                  )}
                </Box>
              </Stack>
            </Grid.Item>

            <Grid.Item>
              <Stack alignX="end">
                <>
                  {showStepsAndDialog && dialog}
                  {!showStepsAndDialog && closeButton}
                </>
              </Stack>
            </Grid.Item>
          </Grid>
        </PageGrid.Item>
      </PageGrid>
      <Divider />
      {showStepsAndDialog && (
        <PageGrid>
          <PageGrid.Item gridColumn={{ initial: '1/-1', md: '4/-1', lg: '4/10' }}>
            <ProgressIndicator>
              {steps.map(step => (
                <ProgressIndicator.Item key={step.children} {...step} />
              ))}
            </ProgressIndicator>
          </PageGrid.Item>
        </PageGrid>
      )}
    </Box>
  );
};
